import { AcendexLayout } from "@/components/acendex/components/layout/AcendexLayout";
import { Toast } from "antd-mobile";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { financeApi } from "../../api/finance-api";
import { kuangjiApi } from "../../api/kuangm-api";
import { getText } from "../../utils/util";
import CenterPage from "./components/centerPage";

export default function LockUpInfo() {
  const uid = localStorage.getItem("uid");
  const navigate = useNavigate();
  const prarm = useParams();
  const [kjInfo, setKjInfo] = useState({} as any);
  const [userCoinInfo, setuserCoinInfo] = useState({});
  const { t: translate } = useTranslation();
  //详情
  const loadKjinfo = async () => {
    let data = await kuangjiApi.detail({ id: prarm?.id, uid });
    if (data.ok) {
      setKjInfo(data.data);
    }
  };

  //用户钱包数据
  const loadUserCoinInfoData = async () => {
    const data = await financeApi.userCoin({ uid });
    if (data.ok) {
      setuserCoinInfo(data.data);
    }
  };

  //购买kj
  const bubKj = async (buyData) => {
    const data = await kuangjiApi.buyKuangji({ uid, ...buyData });
    Toast.show({ content: data.msg });
    loadUserCoinInfoData();
  };
  useEffect(() => {
    loadKjinfo();
    loadUserCoinInfoData();
  }, []);
  return (
    <div className="bg-neutral-900 min-h-screen w-full">
      <AcendexLayout
        theme="light"
        hideBottomBar
        pcTopBarTitle={translate(getText("產品詳細"))}
        mobileTopBarTitle={translate(getText("產品詳細"))}
      >
        <div className="container mx-auto">
          <CenterPage
            userCoinInfo={userCoinInfo}
            kjInfo={kjInfo}
            bubKj={bubKj}
          />
        </div>
      </AcendexLayout>
    </div>
  );
}
